import createAction from '@clearscore-group/lib.helpers.create-action';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import canUseDom from '@clearscore-group/lib.helpers.can-use-dom';
import { getCookie, setCookie } from '@clearscore-group/lib.helpers.cookies';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

/* eslint-disable import/prefer-default-export */
var COOKIE_POLICY_ACCEPT = 'CS/COOKIE_POLICY_ACCEPT';
var typesImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  COOKIE_POLICY_ACCEPT: COOKIE_POLICY_ACCEPT
});

/* eslint-disable import/prefer-default-export */
var acceptCookiePolicy = function acceptCookiePolicy() {
  return createAction(COOKIE_POLICY_ACCEPT);
};
var actionsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  acceptCookiePolicy: acceptCookiePolicy
});
var cookiePolicyAcceptanceCookie = 'CS_ACCEPT_COOKIES';
var initialState = {
  accepted: canUseDom() ? !!getCookie(cookiePolicyAcceptanceCookie) : true
};
var setAcceptanceCookie = function setAcceptanceCookie() {
  var oneYearFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  setCookie(cookiePolicyAcceptanceCookie, 'true', {
    expires: oneYearFromNow
  });
};
var domain$1 = function domain$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;
  switch (type) {
    case COOKIE_POLICY_ACCEPT:
      setAcceptanceCookie();
      return _objectSpread(_objectSpread({}, state), {}, {
        accepted: true
      });
    default:
      return state;
  }
};

/* eslint-disable */
var domain = domain$1;
var reducersImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  domain: domain
});
var cookiePolicyGetAccepted = function cookiePolicyGetAccepted(state) {
  return resolveProp('cookiePolicy.accepted', state) || false;
};

/* eslint-disable */
var getCookiePolicyAccepted = cookiePolicyGetAccepted;
var selectorsImport = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCookiePolicyAccepted: getCookiePolicyAccepted
});
var actions = actionsImport;
var reducers = reducersImport;
var selectors = selectorsImport;
var types = typesImport;
export { actions, reducers, selectors, types };